import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const STRATEGIES = [
  { value: "update_or_create", label: "Update oder Erstellen" },
  { value: "update_or_skip", label: "Update oder Überspringen" },
  { value: "update_only", label: "Nur Update" },
];

const REF_MODES = [
  { value: "entity_table", label: "Entitäts-Tabelle (id_ov)" },
  { value: "mapping_table", label: "Mapping-Tabelle (import_value_mappings)" },
];

export default function MatchStrategySelector({
  mappings,
  match_entity_column,
  external_ref_column,
  write_mode,
  external_ref_mode,
  onChange,
}) {
  const mapped_fields = (mappings ?? [])
    .map((r) => r.target_field)
    .filter(Boolean);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle2">Abgleich-Konfiguration</Typography>

      <Box display="flex" gap={2} flexWrap="wrap">
        <FormControl size="small" sx={{ minWidth: 320 }}>
          <InputLabel>Referenz-Auflösung</InputLabel>
          <Select
            value={external_ref_mode}
            label="Referenz-Auflösung"
            onChange={(e) => onChange("external_ref_mode", e.target.value)}
          >
            {REF_MODES.map((m) => (
              <MenuItem key={m.value} value={m.value}>
                {m.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {external_ref_mode === "mapping_table" ? (
          <TextField
            size="small"
            label="Externe Referenz-Spalte"
            placeholder="z.B. ID_SPARTE"
            value={external_ref_column ?? ""}
            onChange={(e) =>
              onChange("external_ref_column", e.target.value || null)
            }
            sx={{ width: 220 }}
          />
        ) : (
          <FormControl size="small" sx={{ minWidth: 220 }}>
            <InputLabel>Match-Spalte</InputLabel>
            <Select
              value={match_entity_column ?? ""}
              label="Match-Spalte"
              onChange={(e) => onChange("match_entity_column", e.target.value)}
            >
              {mapped_fields.length === 0 && (
                <MenuItem value="" disabled>
                  Erst Mappings definieren
                </MenuItem>
              )}
              {mapped_fields.map((f) => (
                <MenuItem key={f} value={f}>
                  {f}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <FormControl size="small" sx={{ minWidth: 260 }}>
          <InputLabel>Match-Strategie</InputLabel>
          <Select
            value={write_mode}
            label="Match-Strategie"
            onChange={(e) => onChange("write_mode", e.target.value)}
          >
            {STRATEGIES.map((s) => (
              <MenuItem key={s.value} value={s.value}>
                {s.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}

MatchStrategySelector.propTypes = {
  mappings: PropTypes.array.isRequired,
  match_entity_column: PropTypes.string,
  external_ref_column: PropTypes.string,
  write_mode: PropTypes.string.isRequired,
  external_ref_mode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
